import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const CardsFlex = styled.div`
  padding: 10px 15px;
  gap: 10px;
  min-width: 141px;
  min-height: 100%;
  background: ${props => (props?.isSelected ? COLORS.GREY_T_95 : COLORS.WHITE)};
  border-radius: 10px;
  border: 1px solid ${COLORS.GREY_T_90};
  cursor: pointer;
`
export const CardsFlex1 = styled.div`
  padding: 18px 15px;
  gap: 10px;
  min-width: 100%;
  min-height: 100%;
  background: ${COLORS.WHITE};
  border-radius: 10px;
  border: 1px solid ${COLORS.GREY_T_90};
  cursor: pointer;
`

export const CardText = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: 12.5px;
  line-height: 15px;
  text-align: center;
  color: #4b465c;
  text-transform: capitalize;
`
